import { useEffect, useRef, useState } from "react";
import style from "../../styles/pujaDetails.module.css";
import { useTranslation } from "react-i18next";
import "video-react/dist/video-react.css";
import HeadingPuja from "./HeadingPuja";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import { trackEvent } from "@utils/analytics/event-analytics";
import { WEB_ENGAGE } from "@utils/constants";
import { useRouter } from "next/router";
const PujaYoutubeVideo = ({
  videoData,
  data
}) => {
  const videoPlayerRef = useRef(null);
  const wrapperRef = useRef(null);
  const router = useRouter();
  const {
    id,
    eventid
  } = router.query;
  const {
    t
  } = useTranslation();
  const [playing, setPlaying] = useState(false);
  const full = true;
  const [lightMode, setLightMode] = useState(!full);
  const [videoId, setVideoId] = useState("");
  useEffect(() => {
    if (videoData) {
      let t = videoData.split("/").pop();
      t = t.split("?");
      setVideoId(t[0]);
    }
  }, [videoData]);
  const startCallback = entries => {
    entries.forEach(item => {
      if (item.isIntersecting) setTimeout(() => setPlaying(true), 400);else setPlaying(false);
    });
  };
  const changeModeOnScroll = () => {
    if (!videoRef.current) return () => {};
    const e = videoRef.current.getBoundingClientRect();
    const diff = e.top - window.scrollY;
    if (diff > 0 && diff <= 200 && lightMode || videoObserverRef) {
      setLightMode(false);
      window.removeEventListener("scroll", changeModeOnScroll);
    }
  };
  const onErrorHandler = () => {
    // console.error("Error loading video!");
  };
  const startPlaying = () => {
    trackEvent(WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS + " " + WEB_ENGAGE.MEDIA_TYPES.VIDEO + " " + WEB_ENGAGE.EVENT_NAMES.MEDIA_VIEWED, {
      [WEB_ENGAGE.EVENT_PROPERTIES.SCREEN_NAME]: WEB_ENGAGE.SCREEN_NAMES.EVENT_DETAILS,
      [WEB_ENGAGE.EVENT_PROPERTIES.MEDIA_TYPE]: WEB_ENGAGE.MEDIA_TYPES.VIDEO,
      [WEB_ENGAGE.EVENT_PROPERTIES.KRIYA_NAME]: data.name_WE,
      [WEB_ENGAGE.EVENT_PROPERTIES.AMOUNT]: Number(data.eventRegistrationAmount),
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_DEITY_TYPE]: id,
      [WEB_ENGAGE.EVENT_PROPERTIES.EVENT_URL_EXTENSION]: eventid
    });
    setPlaying(true);
  };
  if (!videoData) return null;
  let config = {
    url: videoData,
    muted: true,
    controls: true,
    onError: onErrorHandler,
    width: "100%",
    height: "100%"
  };
  if (lightMode) {
    config.light = frame;
    config.onClickPreview = startPlaying;
  }
  return <>
      <div className={style.eventVideoContainer}>
        <div className={style.eventVideoBorder}>
          <HeadingPuja headline={t("puja-video")} data-sentry-element="HeadingPuja" data-sentry-source-file="PujaYoutubeVideo.jsx" />
          <div className={style.playerWrapper} ref={wrapperRef}>
            {/* <ReactPlayer ref={videoPlayerRef} playing={playing} {...config} /> */}
            <LiteYouTubeEmbed id={videoId} title="Utsav Puja Video" data-sentry-element="LiteYouTubeEmbed" data-sentry-source-file="PujaYoutubeVideo.jsx" />
          </div>
        </div>
      </div>
    </>;
};
export default PujaYoutubeVideo;